import type { CampaignAnswerDraft, CampaignQuestion } from '@/types/campaign'

function selectedValues(
	answer: CampaignAnswerDraft | undefined,
	sourceType: CampaignQuestion['type'],
): string[] {
	if (!answer) return []
	if (sourceType === 'BOOLEAN') {
		return answer.boolean === undefined ? [] : [String(answer.boolean)]
	}
	if (sourceType === 'SINGLE_CHOICE') return answer.text ? [answer.text] : []
	return answer.choices ?? []
}

/**
 * Mesma regra do backend: sem condição a pergunta aparece; com condição, depende da pergunta de origem
 * estar visível e da resposta bater (EQUALS) ou não bater (NOT_EQUALS) com o valor.
 */
export function isQuestionVisible(
	question: CampaignQuestion,
	questionsById: Map<string, CampaignQuestion>,
	answers: Record<string, CampaignAnswerDraft>,
): boolean {
	if (!question.condition) return true

	const source = questionsById.get(question.condition.questionId)
	if (!source || !isQuestionVisible(source, questionsById, answers))
		return false

	const matches = selectedValues(answers[source.id], source.type).includes(
		question.condition.value,
	)
	return question.condition.operator === 'EQUALS' ? matches : !matches
}

/** Uma resposta vazia não conta para a obrigatoriedade */
export function isAnswerEmpty(
	question: CampaignQuestion,
	answer: CampaignAnswerDraft | undefined,
): boolean {
	if (!answer) return true
	switch (question.type) {
		case 'SHORT_TEXT':
		case 'LONG_TEXT':
		case 'SINGLE_CHOICE':
			return !answer.text?.trim()
		case 'BOOLEAN':
			return answer.boolean === undefined
		case 'MULTIPLE_CHOICE':
			return !answer.choices?.length
		case 'SCALE':
			return answer.number === undefined
		case 'FILE':
			return !answer.file
	}
}
